// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"218":"assets/themes/cheers-zone/css/app.fe","222":"assets/themes/cheers-zone/css/app.be","459":"assets/themes/cheers-zone/css/mail/default"}[chunkId] + ".css";
};